import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { NpmRegistryConfig } from "../workspace";
import { ForgeMeta } from "./meta";

export const ForgeProjectContextDependency = z.object({
  packageName: z.string(),
  type: z.literal("npm"),
  version: z.string().default("latest"),
});

export const ForgeProjectContextTailwindConfig = z.object({
  content: z.string(),
  version: z.string(),
});

export const ForgeProjectContext = z.object({
  createdAt: z.coerce.date(),
  definition: z.string(),
  dependencies: z.array(ForgeProjectContextDependency),
  designSystemId: z.string(),
  id: z.string(),
  meta: ForgeMeta,
  name: z.string(),
  npmProxySettings: NpmRegistryConfig,
  platform: z.enum(["React", "Vue", "Angular"]),
  styling: z.enum(["CSS", "Tailwind"]),
  tailwindConfig: ForgeProjectContextTailwindConfig.optional(),
  updatedAt: z.coerce.date(),
  workspaceId: z.string(),
});

export type ForgeProjectContextDependency = z.infer<typeof ForgeProjectContextDependency>;
export type ForgeProjectContextTailwindConfig = z.infer<typeof ForgeProjectContextTailwindConfig>;
export type ForgeProjectContext = z.infer<typeof ForgeProjectContext>;
export type CreateForgeProjectContext = Omit<DbCreateInputOmit<ForgeProjectContext>, "workspaceId">;
export type UpdateForgeProjectContext = Omit<DbUpdate<ForgeProjectContext>, "workspaceId">;
